export const ReportIncidentApi = {
  ReportIncidentApi: '/support/proposal',
  ReportIncidentImages: '/upload/file',
};
